import type { ReactNode } from 'react';

type Tone = 'muted' | 'new' | 'contacted' | 'qualified' | 'won' | 'lost' | 'accent' | 'live';

const TONES: Record<Tone, { bg: string; fg: string; dot: string }> = {
  muted: { bg: '#F2F2F5', fg: '#6B7280', dot: '#9CA3AF' },
  new: { bg: '#FFFBEB', fg: '#92400E', dot: '#F59E0B' },
  contacted: { bg: '#EFF6FF', fg: '#1D4ED8', dot: '#3B82F6' },
  qualified: { bg: '#F5F3FF', fg: '#5B21B6', dot: '#8B5CF6' },
  won: { bg: '#ECFDF5', fg: '#047857', dot: '#10B981' },
  lost: { bg: '#FEF2F2', fg: '#B91C1C', dot: '#EF4444' },
  accent: { bg: '#EEF0FF', fg: '#3730A3', dot: '#6366F1' },
  live: { bg: '#ECFDF5', fg: '#047857', dot: '#10B981' },
};

interface Props {
  tone?: Tone;
  dot?: boolean;
  children: ReactNode;
}

export const Pill = ({ tone = 'muted', dot = false, children }: Props) => {
  const t = TONES[tone];
  return (
    <span className="pill" style={{ background: t.bg, color: t.fg }}>
      {dot && <span className="block w-[5px] h-[5px] rounded-full" style={{ background: t.dot }} />}
      {children}
    </span>
  );
};
